import { useCallback } from "react";
import {
  useEventArchiveMutation,
  useEventAskValidationMutation,
  useEventReopenMutation,
} from "../../apiSlice";
import { notification } from "antd";
import { getErrorMessage } from "../../../../utils/errors/errors";
import {
  FetchEventsQuery,
  RefetchEventQuery,
} from "../../../../types/reactQueries";
import { NavigateFunction } from "react-router-dom";

type Options = {
  fetchEvents?: FetchEventsQuery;
  fetchEvent?: RefetchEventQuery;
  navigate?: NavigateFunction;
};

export const useCrudEvent = ({
  fetchEvents,
  fetchEvent,
  navigate,
}: Options) => {
  /**
   * Archive/Delete
   */
  const [deleteEvent, { isLoading: isDeleting }] = useEventArchiveMutation();
  const onDelete = useCallback(
    async (id: number) => {
      try {
        console.log("deleteEvent id", id);
        await deleteEvent(id).unwrap();
        // Success notification
        notification.success({
          message: "ÃvÃ©nement supprimÃ©",
          description: `L'Ã©vÃ©nement a Ã©tÃ© supprimÃ© avec succÃ¨s.`,
        });
        if (fetchEvents) {
          await fetchEvents("").unwrap();
        } else {
          console.warn("The 'onDelete' fn needs 'fetchEvents' to be defined");
        }
      } catch (error) {
        console.error("deleteEvent error", error);
        notification.error({
          message: "Erreur",
          description: getErrorMessage(error),
        });
      }
    },
    [deleteEvent, fetchEvents],
  );

  const [archiveEventRequest, { isLoading: isArchiving }] =
    useEventArchiveMutation();
  const archiveEvent = useCallback(
    async (id: number) => {
      try {
        await archiveEventRequest(Number(id)).unwrap();
        notification.success({
          message: "L'Ã©vÃ©nement a Ã©tÃ© archivÃ© avec succÃ¨s",
        });
        if (navigate) {
          navigate("/events");
        } else {
          console.warn("The 'archiveEvent' fn needs 'navigate' to be defined");
        }
      } catch (error) {
        console.error("archiveEvent error", error);
      }
    },
    [archiveEventRequest, navigate],
  );

  /**
   *
   */

  /**
   * Ask validation
   */
  const [askValidation, { isLoading: isAskingValidation }] =
    useEventAskValidationMutation();
  const onAskValidation = useCallback(
    async (id: number) => {
      try {
        console.log("askValidation id", id);
        await askValidation(id).unwrap();
        // Success notification
        notification.success({
          message: "Demande de validation effectuÃ©e.",
        });
        if (fetchEvent) {
          await fetchEvent().unwrap();
        } else {
          console.warn(
            "The 'askValidation' fn needs 'fetchEvent' to be defined",
          );
        }
      } catch (error) {
        console.error("askValidation error", error);
        notification.error({
          message: "Erreur",
          description: getErrorMessage(error),
        });
      }
    },
    [askValidation, fetchEvent],
  );

  /**
   * Reopen
   */
  const [reopen, { isLoading: isReopening }] = useEventReopenMutation();
  const onReopen = useCallback(
    async (id: number) => {
      try {
        console.log("reopen id", id);
        await reopen(id).unwrap();
        // Success notification
        notification.success({
          message: "ÃvÃ©nement rÃ©ouvert",
          description: `L'Ã©vÃ©nement a Ã©tÃ© rÃ©ouvert avec succÃ¨s.`,
        });
        if (fetchEvents) {
          await fetchEvents("").unwrap();
        } else {
          console.warn("The 'reopen' fn needs 'fetchEvents' to be defined");
        }
      } catch (error) {
        console.error("reopen error", error);
        notification.error({
          message: "Erreur",
          description: getErrorMessage(error),
        });
      }
    },
    [reopen, fetchEvents],
  );

  return {
    // Delete/archive
    onDelete,
    isDeleting,
    archiveEvent,
    isArchiving,
    // Ask validation
    onAskValidation,
    isAskingValidation,
    // Reopen
    onReopen,
    isReopening,
  };
};
